exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-new-membership-bs-modal #new-membership-form-table tbody tr td:nth-child(2) {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n#add-new-membership-bs-modal .error-span {\n  font-size: 80%;\n  color: red;\n}\n#add-new-membership-bs-modal .table-section-row {\n  padding-top: 10px;\n  column-span: 3;\n}", ""]);

// exports
